import GifsModule from "../Gifs/GifsModule";

function Home() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  return <GifsModule value="" />;
}

export default Home;
